import { Component, inject, OnInit } from '@angular/core';
import { RealmService } from '@/app/services/realm.service';
import { CompanyService } from '@/app/services/company.service';
import { GameTemplatesService } from '@/app/services/game-templates.service';
import { AuthService } from '@/app/services/auth.service';
import { NeedsAttentionWidget } from './components/needs-attention-widget';
import { KpisWidget } from './components/kpis-widget';
import { RecentCompaniesWidget } from './components/recent-companies-widget';
import { QuickActionsWidget } from './components/quick-actions-widget';
import { AiAssistJobsWidget } from './components/ai-assist-jobs-widget';
import { VendorBalanceWidget } from './components/vendor-balance-widget';

@Component({
    standalone: true,
    selector: 'app-dashboard',
    imports: [
        NeedsAttentionWidget,
        KpisWidget,
        RecentCompaniesWidget,
        QuickActionsWidget,
        AiAssistJobsWidget,
        VendorBalanceWidget,
    ],
    template: `
        <div class="flex flex-col gap-6">
            <app-needs-attention-widget />

            <div class="grid grid-cols-12 gap-6">
                <app-dashboard-kpis />
            </div>

            <div class="grid grid-cols-12 gap-6">
                @if (isGlobal()) {
                    <div class="col-span-12 lg:col-span-8">
                        <app-recent-companies-widget />
                    </div>
                    <div class="col-span-12 lg:col-span-4">
                        <app-quick-actions-widget />
                    </div>
                } @else {
                    <div class="col-span-12">
                        <app-quick-actions-widget />
                    </div>
                }
            </div>

            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 lg:col-span-6">
                    <app-ai-assist-jobs-widget />
                </div>
                <div class="col-span-12 lg:col-span-6">
                    <app-vendor-balance-widget />
                </div>
            </div>
        </div>
    `,
})
export class Dashboard implements OnInit {
    private readonly realmService = inject(RealmService);
    private readonly companyService = inject(CompanyService);
    private readonly templatesService = inject(GameTemplatesService);
    private readonly authService = inject(AuthService);

    protected readonly isGlobal = this.authService.isGlobalAdmin;

    ngOnInit(): void {
        this.realmService.loadRealms();
        this.templatesService.ensureTemplatesLoaded();
        // listCompanies requires global admin — only fetch when allowed.
        if (this.isGlobal()) {
            this.companyService.loadCompanies();
        }
    }
}
